module.exports = __webpack_public_path__ + "media/images/credit_card-a6d23e693922b45fb982ee17f3799d5b.png";